import React from 'react';

/**
 * Serves as a card wrapper for Seller/ Studio cards.
 * The gig_page_perseus decorator is added in order
 * for fit3 components css to be applied and not effect
 * current fit2 components in the project.
 */
const ProfileCard = ({children}) => (
    <div className="profile-card">
        {children}
    </div>
);

export default ProfileCard;
